import type {
  ExternalSystemOrientation,
  ExternalSystemType,
  JobRunState,
  JobState,
  RunDateType,
} from 'src/apis/transparency-reporting/types';
import type { StatusProps } from 'src/components/data-display/status-display';
import { labelsToOptions } from 'src/utils/labels-to-options';
import { labelsToValues } from 'src/utils/labels-to-values';

export const jobStateLabels: Record<JobState, string> = {
  ACTIVE: 'Active',
  INACTIVE: 'Inactive',
};

export const jobStateValues = labelsToValues(jobStateLabels);
export const jobStateOptions = labelsToOptions(jobStateLabels);

export const jobStateVariants: Record<
  keyof typeof jobStateLabels,
  StatusProps['variant']
> = {
  ACTIVE: 'success',
  INACTIVE: 'inactive',
};

export const jobRunStateLabels: Record<JobRunState, string> = {
  ERROR: 'Unsuccessful',
  SUCCESS: 'Successful',
  SUCCESS_NOT_SENT: 'Successful, Not Sent',
  RUNNING: 'Running',
  SKIPPED: 'Skipped',
};

export const jobRunStateValues = labelsToValues(jobRunStateLabels);
export const jobRunStateOptions = labelsToOptions(jobRunStateLabels);

export const jobRunStateVariants: Record<
  keyof typeof jobRunStateLabels,
  StatusProps['variant']
> = {
  ERROR: 'error',
  SUCCESS: 'success',
  SUCCESS_NOT_SENT: 'success',
  RUNNING: 'warning',
  SKIPPED: 'inactive',
};

export const jobRunSystemLabels: Record<ExternalSystemType, string> = {
  ACER: 'ACER',
  CM: 'CM',
  ENTSOG: 'ENTSOG',
  GDM: 'GDM',
  MAM: 'MAM',
  TAG: 'TAG',
  TR: 'TR',
};

export const jobRunSystemValues = labelsToValues(jobRunSystemLabels);
export const jobRunSystemOptions = labelsToOptions(jobRunSystemLabels);

export const jobRunOrientationLabels: Record<
  ExternalSystemOrientation,
  string
> = {
  EXPORT: 'Export',
  IMPORT: 'Import',
};

export const jobRunOrientationValues = labelsToValues(jobRunOrientationLabels);
export const jobRunOrientationOptions = labelsToOptions(
  jobRunOrientationLabels
);

export const runDateTypeLabels: Record<RunDateType, string> = {
  RUN: 'Time of Creation',
  VALUE: 'Reporting Period',
};

export const runDateTypeValues = labelsToValues(runDateTypeLabels);
export const runDateTypeOptions = labelsToOptions(runDateTypeLabels);
